import React from "react";
import ReactDOM from "react-dom";
import { Provider } from 'react-redux'
import PageFront from "./PageFront";
import PageFrontOverview from "./PageFrontOverview";
import PageOverview from "./PageOverview";
import SiteHeader from "./SiteHeader";
import SiteFooter from "./SiteFooter";
// import "../../../assets-static/openplayerjs-youtube/dist/openplayerjs-youtube.min.js"
import "./entryHelpers"
import isIframe from "./functions/isIframe";
import isPmkinoWebApp from "./functions/webapp/isPmkinoWebApp";
import setPmkinoWebAppState from "./functions/webapp/setPmkinoWebAppState";
import AdvertisementFireplaceWrapper from './Advertisements/AdvertisementFireplaceWrapper'
import { store } from './store.js'
import StylingContainerForIframes from "./General/StylingContainerForIframes.jsx";
import createPmkinoWebAppState from "./functions/webapp/createPmkinoWebAppState.js";

const iOS =
    ([
        "iPad Simulator",
        "iPhone Simulator",
        "iPod Simulator",
        "iPad",
        "iPhone",
        "iPod",
    ].includes(navigator.platform) ||
        (navigator.userAgent.includes("Mac") && "ontouchend" in document)) &&
    !window.MSStream;
const Firefox = /Firefox/.test(navigator.userAgent) && !window.MSStream;
const Android = /Android/.test(navigator.userAgent) && !window.MSStream;
const Mobile = /Mobile/.test(navigator.userAgent) && !window.MSStream;

if ((Android && Mobile && Firefox) || iOS) {
    document.querySelector("html").classList.add("is-ios");
}

if(isPmkinoWebApp()){
  setPmkinoWebAppState()
}


const elemFront = document.querySelector("#front-page")
const elemOverview = document.querySelector("#overview-page")
const elemFrontOverview = document.querySelector("#overview-page-front")
const elemOverviewMainSlider = document.querySelector("#overview-page-with-slider")
const elemSiteHeader = document.querySelector("#site-header")
const elemSiteFooter = document.querySelector("#site-footer")
const elemFireplaceAdvertisement = document.querySelector("#fireplace-wrapper")
const elemFireplaceAdvertisementSmall = document.querySelector("#fireplace-wrapper-small")
const elemStylingContainer = document.querySelector("#pm-styling-wrapper")

if (elemFront) {
  if (Mobile) {
    ReactDOM.render(<Provider store={store}><PageFrontOverview isMobile={Mobile} /></Provider>, elemFront);
  } else {
    ReactDOM.render(<Provider store={store}><PageFront /></Provider>, elemFront);
  }
} else if (elemOverview) {
  ReactDOM.render(<Provider store={store}><PageOverview /></Provider>, elemOverview);
} else if (elemFrontOverview) {
  ReactDOM.render(<Provider store={store}><PageFrontOverview isMobile={Mobile}/></Provider>, elemFrontOverview);
} else if (elemOverviewMainSlider) {
  ReactDOM.render(<Provider store={store}><PageFrontOverview isOverviewPage={true}/></Provider>, elemOverviewMainSlider);
} else if (!isIframe()) {
  if (elemSiteHeader) {
    ReactDOM.render(<Provider store={store}><SiteHeader /></Provider>, elemSiteHeader);
  }
    
  if(elemFireplaceAdvertisement) {
    ReactDOM.render(<Provider store={store}><AdvertisementFireplaceWrapper /></Provider>, elemFireplaceAdvertisement);
  }
    
  if(elemFireplaceAdvertisementSmall) {
    ReactDOM.render(<Provider store={store}><AdvertisementFireplaceWrapper showSmallVersion={true} /></Provider>, elemFireplaceAdvertisementSmall);
  }

  if (elemSiteFooter) {
      ReactDOM.render(<Provider store={store}><SiteFooter /></Provider>, elemSiteFooter);
  }
} else if(isIframe()) {
    ReactDOM.render(<Provider store={store}><StylingContainerForIframes /></Provider>, elemStylingContainer);
}
